<template>
  <label
    class="cursor-pointer q-pr-xs q-pl-xs all-pointer-events"
    v-ripple
    style="display: block; height: 26px"
  >
    <q-file
      class="hidden"
      :multiple="true"
      v-model="files"
      :max-total-size="100000000"
    />
    <PaperclipIcon />
    <q-tooltip>Anexar Arquivos</q-tooltip>
  </label>
</template>

<script>
import { mapActions } from 'vuex'
import PaperclipIcon from '@/assets/icons/paperclip.svg'

export default {
  name: 'UploadButton',

  components: {
    PaperclipIcon
  },

  props: {
    refId: {},
    refType: {},
    isDisabled: { default: false }
  },

  data () {
    return { files: null }
  },

  methods: {
    ...mapActions({
      startUpload: 'uploadModule/startUpload'
    }),

    onFiles (files) {
      if (files?.length) {
        this.startUpload({
          refId: this.refId,
          refType: this.refType,
          files
        })
      }

      this.files = null
    }
  },

  watch: {
    files: {
      deep: true,
      handler (files) {
        const hasFiles = Array.isArray(files) && files.length
        if (!hasFiles) return
        this.$nextTick(() => this.onFiles([...files]))
      }
    }
  }
}

</script>
<style lang="sass">
.hidden
  width: 0
  height: 0
  display: block
</style>
